import { EServiceId } from '../../types/reducers/publishTerms';
import { actionGenerator, IReduxAction } from '../../utils/actions';

export const CHANGE_ACTIVE_SERVICE_ID = 'PUBLISH_TERMS :: CHANGE_ACTIVE_SERVICE_ID';

export type TChangeActiveServiceIdAction = IReduxAction<typeof CHANGE_ACTIVE_SERVICE_ID, EServiceId>;

export const changeActiveServiceId = actionGenerator<typeof CHANGE_ACTIVE_SERVICE_ID, EServiceId>(
  CHANGE_ACTIVE_SERVICE_ID,
);
